"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
const _ = __importStar(require("lodash"));
const vue_property_decorator_1 = require("vue-property-decorator");
const vue_class_component_1 = require("vue-class-component");
const core_1 = require("@integro/core");
let UCContractServiceFeesEditor = class UCContractServiceFeesEditor extends (0, vue_class_component_1.mixins)(core_1.UserComponentMixin) {
    componentMetadata = {
        kind: "usercontrol",
    };
    beforeCreate() {
    }
    getInitialSelectedItem(...args) {
        const [items] = args;
        const today = new Date();
        let orderedItems = _.orderBy(items, 'valid_from');
        const result = _.chain(orderedItems).filter(p => p.valid_from >= this.$fn.today && (p.valid_to == null || p.valid_to <= this.$fn.today)).head().value();
        if (!result && items.length) {
            return _.last(orderedItems);
        }
        return result;
    }
    createCopy(...args) {
        const [source] = args;
        const copy = _.cloneDeep(source);
        for (let attr of ["id", "etag", "$etag"]) {
            delete copy[attr];
        }
        if (copy.links) {
            delete copy.links["self"];
        }
        copy.valid_from = this.$fn.today();
        copy.contract_id = this.service.contract.contract_id;
        copy.service_id = this.service.id;
        this.items.push(copy);
        this.selectedItem = copy;
        console.log("copy crated", copy, this.selectedItem);
    }
    service;
    onService(newValue, oldValue) {
        if (_.isEqual(newValue, oldValue))
            return;
        this.loadDataThrottled("service");
    }
    labelAlign;
    onLabel_align(newValue, oldValue) {
        if (_.isEqual(newValue, oldValue))
            return;
        this.loadDataThrottled("labelAlign");
    }
    readonly;
    onReadonly(newValue, oldValue) {
        if (_.isEqual(newValue, oldValue))
            return;
        this.loadDataThrottled("readonly");
    }
    items;
    async $$load_items() {
        return this.service.fees ? this.service.fees.slice() : [];
    }
    selectedItem;
    async $$load_selectedItem() {
        return this.getInitialSelectedItem(this.items);
    }
    ux;
    b_6705964765214521_style;
    b_3943151158818434_displayParent;
    dataMembers = ['items', 'selectedItem', 'ux', 'b_6705964765214521_style', 'b_3943151158818434_displayParent'];
    data() {
        return {
            ...this.mixinData(),
            actions: this.getActions(),
            ...{
                items: null,
                selectedItem: null,
                ux: null,
                b_6705964765214521_style: {
                    minWidth: "300px",
                },
                b_3943151158818434_displayParent: false,
            },
        };
    }
    get canCreateCopy() {
        if (this.loaded) {
            return this.selectedItem && this.selectedItem.id != null;
        }
        return null;
    }
    async evh_7315092382398562_reload(event, scope) {
        return await this.actions.evh_7315092382398562_reload.executeFromDOM(this, event, scope);
    }
    async act_6806515264385235_script_9146_getActionArgs_value($event) {
        this.createCopy(this.selectedItem);
    }
    async act_6806515264385235_script_9146_getActionArgs($event) {
        return {
            value: () => this.act_6806515264385235_script_9146_getActionArgs_value($event),
        };
    }
    async evh_6806515264385235_clickPreventStop(event, scope) {
        return await this.actions.evh_6806515264385235_clickPreventStop.executeFromDOM(this, event, scope);
    }
    actions;
    getActions() {
        const act_7315092382398562_reloadComponentData_9144 = new core_1.actions.ReloadComponentDataAction({
            events: [],
        });
        const evh_7315092382398562_reload_9143 = new core_1.actions.EventHandlerImpl({
            action: act_7315092382398562_reloadComponentData_9144,
            event: "reload",
            displayName: "reloadComponentData",
        });
        const evh_7315092382398562_reload = new core_1.actions.EventHandlerGroup({
            handlers: [evh_7315092382398562_reload_9143],
        });
        const act_6806515264385235_script_9146 = new core_1.actions.ScriptAction({
            actionArgs: this.act_6806515264385235_script_9146_getActionArgs,
            events: [],
        });
        const evh_6806515264385235_clickPreventStop_9145 = new core_1.actions.EventHandlerImpl({
            action: act_6806515264385235_script_9146,
            event: "click.prevent.stop",
            displayName: "script",
        });
        const evh_6806515264385235_clickPreventStop = new core_1.actions.EventHandlerGroup({
            handlers: [evh_6806515264385235_clickPreventStop_9145],
        });
        return {
            act_7315092382398562_reloadComponentData_9144,
            evh_7315092382398562_reload_9143,
            evh_7315092382398562_reload,
            act_6806515264385235_script_9146,
            evh_6806515264385235_clickPreventStop_9145,
            evh_6806515264385235_clickPreventStop,
        };
    }
};
__decorate([
    (0, vue_property_decorator_1.Prop)({
        required: true,
        type: Object,
    }),
    __metadata("design:type", Object)
], UCContractServiceFeesEditor.prototype, "service", void 0);
__decorate([
    (0, vue_property_decorator_1.Watch)('service'),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object, Object]),
    __metadata("design:returntype", void 0)
], UCContractServiceFeesEditor.prototype, "onService", null);
__decorate([
    (0, vue_property_decorator_1.Prop)({
        type: String,
        default: "right",
    }),
    __metadata("design:type", String)
], UCContractServiceFeesEditor.prototype, "labelAlign", void 0);
__decorate([
    (0, vue_property_decorator_1.Watch)('labelAlign'),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object, Object]),
    __metadata("design:returntype", void 0)
], UCContractServiceFeesEditor.prototype, "onLabel_align", null);
__decorate([
    (0, vue_property_decorator_1.Prop)({
        type: Boolean,
    }),
    __metadata("design:type", Boolean)
], UCContractServiceFeesEditor.prototype, "readonly", void 0);
__decorate([
    (0, vue_property_decorator_1.Watch)('readonly'),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object, Object]),
    __metadata("design:returntype", void 0)
], UCContractServiceFeesEditor.prototype, "onReadonly", null);
UCContractServiceFeesEditor = __decorate([
    (0, vue_property_decorator_1.Component)()
], UCContractServiceFeesEditor);
exports.default = UCContractServiceFeesEditor;
vue_property_decorator_1.Vue.component("UCContractServiceFeesEditor", UCContractServiceFeesEditor);
